import { useState, type ReactElement } from 'react';
import { MediaThumb } from '../MediaThumb/MediaThumb';
import { PreviewKind, previewSourceOf, type MediaPreviewMedia, type PreviewSource } from '../model/media-preview';
import styles from './MediaPreview.module.scss';

export interface MediaPreviewProps {
  media: MediaPreviewMedia;
  /** По умолчанию — по формату медиа; истории подставляют свою картинку. */
  source?: PreviewSource;
}

/** POST-UC-13, POST-UC-13.CC-1: медиа крупно; файл не отдался (лимит трафика, ошибка) — превью. */
export function MediaPreview({ media, source = previewSourceOf(media) }: MediaPreviewProps): ReactElement {
  const [failed, setFailed] = useState(false);
  if (source.kind === PreviewKind.Thumb || failed) {
    return (
      <div className={styles.fallback} data-testid="media-preview">
        <MediaThumb media={media} />
      </div>
    );
  }
  if (source.kind === PreviewKind.Video) {
    return <video className={styles.frame} controls preload="metadata" src={source.src} aria-label={media.originalName} data-testid="media-preview" onError={() => setFailed(true)} />;
  }
  return <img className={styles.frame} src={source.src} alt={media.originalName} data-testid="media-preview" onError={() => setFailed(true)} />;
}
